// @flow
import React from 'react'
import styled from 'styled-components'
import Colors from 'components/styles/colors'
import {
  fontSize,
  spacing,
  borderRadius,
} from 'frontend_core/dist/styles/variables'

const Date = styled.span`
  display: inline-block;
  width: 100px;
  padding: ${spacing.small}px;
  font-size: ${fontSize.small}px;
  text-align: center;
  border-radius: ${borderRadius}px;
  background-color: ${Colors.grayE};
`

type PropTypes = {
  text: string,
}

export default (props: PropTypes) => <Date>{props.text}</Date>



// WEBPACK FOOTER //
// ./src/components/atoms/StatusDate/index.jsx